import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/surajsajjan/Desktop/rpcollege/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/surajsajjan/Desktop/rpcollege/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/AboutPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/CampusHighlights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/InstitutionUpdates.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/LoadingScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/PlacementsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/ProgramsPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/WhyChooseUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/components/ui/WhatsAppFloatingButton.tsx");
